import React from 'react';

export default function IconStream() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2545_9709)">
        <rect width="16" height="16" fill="white" />
        <path
          d="M12.6875 2.375H3.3125C2.79375 2.375 2.375 2.79375 2.375 3.3125V12.6875C2.375 13.2062 2.79375 13.625 3.3125 13.625H12.6875C13.2062 13.625 13.625 13.2062 13.625 12.6875V3.3125C13.625 2.79375 13.2062 2.375 12.6875 2.375Z"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.74805 6.28809H10.248"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.74805 9.68652H10.248"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_2545_9709">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
